export const ProjectsDataStructure = [
    {
        title: 'Portfolio Frontend',
        description: 'Project to create this web app.',
        githubUrl: 'https://www.github.com/mcbsf/portfolio-frontend',
    },
    {
        title: 'Portfolio Q&A Bot',
        description: 'Project to create the chatbot in this page',
        githubUrl: 'https://www.github.com/mcbsf/portfolio-qa-bot',
    },
    {
        title: 'Redis Like',
        description: 'Project to simulate Redis, with all basic commands available to be used via sheel or importing the Redisclass and using it',
        githubUrl: 'https://www.github.com/mcbsf/redis_like',
    },
    {
        title: 'Legislators Analyser',
        description: 'Project to extract analysis about the relation between legislators, bills and votes',
        githubUrl: 'https://github.com/mcbsf/legislation-bills-analyser',
    },
    {
        title: 'Requirements Engineering',
        description: 'Project to document requirements engineering processes, offering AS IS/TO BE models for Strategic Dependency Model, Strategic Rationale Model and Business Process Model Notion.',
        githubUrl: 'https://github.com/LeonardoGaldino/iStarModels',
    },
    {
        title: 'Crypto Analyser',
        description: 'A academic project that analyses reddit comment sentiments about crypto currency',
        githubUrl: 'https://github.com/mcbsf/criptoanalysis',
    }
    // Add more projects here
];
